export default __webpack_public_path__ + "static/media/german_gray.286f36d9.svg";